import { Link } from "react-router-dom"
import Navbar from "../Navbar/Navbar"
import "./Question_2.css"
import { useState } from "react"

const Question_2 = () => {
    const numbers = ["<1","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18",">18"]
    const [numb,setnumb] = useState(3)

  return (
      <div className='portal-kiga-question-2-main'>
      <Navbar/>
      <section className='portal-kiga-question-2-section'>
       <div className='portal-kiga-question-2-section-header'>
        <p>How old is the participant?</p>
       </div>
       <div className="portal-kiga-question-2-section-grid">
        {
         numbers?.map((item,key)=>(
         <div className="portal-kiga-question-2-section-grid-number" key={key} >
           <Link to={`/portal/booking/wizard-question-3/ages=${item}`} >{item}</Link>
         </div>
         ))
        }
       </div>
      </section>
      <footer className='portal-kiga-question-2-footer'>

        <div className='portal-kiga-question-2-footer-close'>
         <div className='portal-kiga-question-2-footer-close-btn'>
          <Link to="/">X</Link>
         </div>
         <div className='portal-kiga-question-2-footer-close-title'>
          <p>Cancel</p>
         </div>
        </div>

        <div className='portal-kiga-question-2-footer-right'>
         <div className='portal-kiga-question-2-footer-right-btn'>
          <Link to="/">{'>'}</Link>
         </div>
         <div className='portal-kiga-question-2-footer-right-title'>
          <p>Next</p>
         </div>
        </div>

      </footer>
    </div>
  )
}

export default Question_2